module.exports = __webpack_public_path__ + "img/collection-engagementRingsCollectionRings.5703e8f.jpg";